import React, { useState } from 'react'

import CloseArrow from '../../../../images/close.svg'
import Logo from '../../../../images/logo.svg'
import { CookiesService } from '../../../../services'
import Switch from './Switch'
import './cookiesModal.less'

type Props = {
  onClose: () => void
}

const CookiesModal: React.FC<Props> = ({ onClose }) => {
  const initialState = CookiesService.currentState()

  const [cookiePreferences, setCookiePreference] = useState<{ [key: string]: boolean }>(initialState)
  const acceptAll = () => {
    CookiesService.acceptAll()
    onClose()
  }

  const confirm = () => {
    CookiesService.updateCookies({ ...cookiePreferences })
    onClose()
  }

  const toggle = (cookieCategory: string) => {
    cookiePreferences[cookieCategory] = !cookiePreferences[cookieCategory]
    setCookiePreference({ ...cookiePreferences })
  }

  return (
    <>
      <div className="cookies-modal">
        <div className="cookies-modal__header">
          <div className="cookies-modal__logo">
            <img src={Logo} />
          </div>
          <div>
            <button className="modal__close" onClick={onClose}>
              <img src={CloseArrow} />
            </button>
          </div>
        </div>
        <div className="cookies-modal__info">
          <div className="cookies-modal__title">
            <span>Cookie Settings</span>
          </div>
          <div className="description">
            <span>
              Cookie Settings When you visit any of our websites, it may store or retrieve information on your browser,
              mostly in the form of cookies. This information might be about you, your preferences or your device and is
              mostly used to make the site work as you expect it to. The information does not usually directly identify
              you, but it can give you a more personalized web experience. Because we respect your right to privacy, you
              can choose not to allow some types of cookies. Click on the different category headings to find out more
              and manage your preferences. Please note, blocking some types of cookies may impact your experience of the
              site and the services we are able to offer.
            </span>
          </div>
        </div>
        <div className="wrapper">
          <div className="buttons">
            <div className="button accept" onClick={acceptAll}>
              <span>ACCEPT ALL COOKIES</span>
            </div>
          </div>

          <div className="cookies-modal__preferences">
            <div className="cookies-modal__preferences-title">
              <span>Manage Consent Preferences</span>
            </div>
            <div className="preference">
              <span>Functional Cookies</span>
              <div onClick={() => toggle('functional_cookies_accepted')}>
                <Switch enabled={!!cookiePreferences['functional_cookies_accepted']}></Switch>
              </div>
            </div>
            <div className="preference">
              <span>Targeting Cookies</span>
              <div onClick={() => toggle('targeting_cookies_accepted')}>
                <Switch enabled={!!cookiePreferences['targeting_cookies_accepted']}></Switch>
              </div>
            </div>
            <div className="preference">
              <span>Analytical/Performance Cookies</span>
              <div onClick={() => toggle('analytical_cookies_accepted')}>
                <Switch enabled={!!cookiePreferences['analytical_cookies_accepted']}></Switch>
              </div>
            </div>
            <div className="preference">
              <span>Strictly Necessary Cookies</span>
              <div>
                <Switch enabled={cookiePreferences['strictly_necessary_cookies_accepted']}></Switch>
              </div>
            </div>
          </div>

          <div className="cookies-modal__footer">
            <div className="buttons">
              <div className="button confirm" onClick={confirm}>
                <span>CONFIRM MY CHOICES</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CookiesModal
